import { type MetaFunction } from '@remix-run/node'
import { NavLink } from '@remix-run/react'
import { Button } from '#app/components/ui/button.tsx'

export const meta: MetaFunction = () => [{ title: 'Kring van licht' }]

export default function Index() {
	return (
		<main className="font-poppins absolute top-0 flex h-screen w-screen flex-col items-center justify-center">
			<div className="absolute top-8 z-10 flex h-screen w-screen flex-col items-center justify-center transition-opacity duration-1000">
				<div className="fibonacci-face">
					<div className="circle circle-1 bg-[#61bea2]"></div>
					<div className="circle circle-2 bg-[#529ca0]"></div>
					<div className="circle circle-3 bg-[#61bea2]"></div>
					<div className="circle circle-4 bg-[#529ca0]"></div>
					<div className="circle circle-5 bg-[#61bea2]"></div>
					<div className="circle circle-6 bg-[#529ca0]"></div>
					<div className="circle circle-7 bg-[#61bea2]"></div>
					<div className="circle circle-8 bg-[#529ca0]"></div>
					<div className="circle circle-9 bg-[#61bea2]"></div>
					<div className="circle circle-10 bg-[#529ca0]"></div>
					<div className="circle circle-11 bg-[#61bea2]"></div>
					<div className="circle circle-12 bg-[#529ca0]"></div>
				</div>
				<div className="mt-20 animate-slide-top p-2 text-2xl font-medium text-white [animation-delay:3s] [animation-fill-mode:backwards]">
					Kring van licht
				</div>
				<div className="max-w-md animate-slide-top p-2 text-center text-white [animation-delay:4s] [animation-fill-mode:backwards]">
					<p>
						Ongelofelijk mooi om te zien hoe de 540 lichtjes samen straalden;
						dank voor jullie warmte.
					</p>
				</div>
			</div>
		</main>
	)
}
